import {Check} from "@sparkware/app-utils";
import {IAbTestingFeature} from "./ab-testing-feature-data-provider.service.interface";

export const abTestingFeatureIsValid = (featureObject: IAbTestingFeature, featureProperties: string[]): any => {

  if (Check.isNullOrUndefined(featureObject) || Check.isNullOrUndefined(featureObject.Properties)) {
    return false;
  }

  for (let i = 0; i < featureProperties.length; i++) {
    if (Check.isNullOrUndefined(featureObject.Properties[featureProperties[i]])) {
      return false;
    }
  }

  return true;
};

export function getAbFeaturePropertyValue(featureObject: IAbTestingFeature, propertyName: string): any {
  const properties = featureObject.Properties;
  if(!properties) {
    return null;
  }

  return properties[propertyName?.toLowerCase()];

}

export function isAbFeaturePropertyValueTrue(featureObject: IAbTestingFeature, propertyName: string): boolean {
  return getAbFeaturePropertyValue(featureObject, propertyName)?.toLowerCase() === 'true'
}